/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { Route, Routes } from 'react-router-dom'

import AppLayout from '../app/Layout'
import Home from '../pages/Home'

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Home />} />
      </Route>
    </Routes>
  )
}

export default AppRoutes
